// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/departure-radio-sequence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/departure-radio-sequence/departure-radio-sequence.js';

mount([g0]);
